// Deep path, not the `@shared/lib/access` barrel: this entry stays free of `@graphql-v2` and the apps.
import { appForPath } from '@shared/lib/access/crossApp';
import { lazy, Suspense } from 'react';

const AdminApp = lazy(() =>
  import('../../admin/src/AdminApp').then((m) => ({ default: m.AdminApp })),
);
const StudentApp = lazy(() =>
  import('../../student/src/StudentApp').then((m) => ({ default: m.StudentApp })),
);

/**
 * The token's claims, for a path that does not name its app (`/`, an admin URL). Never rely on
 * localStorage `auth.role` — only the admin app writes it.
 */
function tokenClaims(): { role?: string } | null {
  try {
    const token = localStorage.getItem('auth.accessToken');
    if (!token) return null;
    const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(b64)) as { role?: string };
  } catch {
    return null; // malformed or missing token
  }
}

export function Shell() {
  const path = window.location.pathname;

  // Legacy redirects
  if (path === '/sign-in' || path === '/v2/login' || path === '/v1/sign-in') {
    window.location.replace('/login');
    return null;
  }

  // 3B-4 / FE-8 (TML-5374): which app a path belongs to — and, on an ambiguous one, which a token's
  // role opens — is decided once, in `@shared/lib/access/crossApp`; the student app's catch-all and the
  // admin app's landings ask the same function. Editors, Group Managers and a level this build does not
  // know open the admin app, which re-reads the level from `myAccess`.
  const app = appForPath(path, tokenClaims());

  return (
    <Suspense fallback={null}>
      {app === 'student' ? <StudentApp /> : <AdminApp />}
    </Suspense>
  );
}
